import { createFileRoute } from '@tanstack/react-router'
import { CreditAllocationPage } from '@/features/account/pages/credits/credit-allocation-page'

export interface CreditAllocationSearch {
  /** Deep-link target: pre-open the Allocate dialog for this brand (from the
   *  Brands list / Brand settings "Allocate" affordances). */
  brand?: string
}

/** D3 — Per-brand allocation & caps. */
export const Route = createFileRoute('/_ws/w/$workspaceId/credits/allocation')({
  validateSearch: (search: Record<string, unknown>): CreditAllocationSearch => ({
    brand: typeof search.brand === 'string' ? search.brand : undefined,
  }),
  component: CreditAllocationPage,
})
